import { type ComponentType } from 'react';

import { createApiRef, useApiHolder } from '@backstage/core-plugin-api';

export interface CreateMeasurementDialogExtensionsApi {
  component: ComponentType<{ onClose: () => void }>;
}

export const createMeasurementDialogExtensionsApiRef =
  createApiRef<CreateMeasurementDialogExtensionsApi>({
    id: 'plugin.confidence-metrics.create-measurement-dialog-extension',
  });

export const useCreateMeasurementDialogExtension = ():
  | ComponentType<{ onClose: () => void }>
  | undefined => {
  const apis = useApiHolder();
  return apis.get(createMeasurementDialogExtensionsApiRef)?.component;
};
